import { useTelegram } from '../hooks/useTelegram'
import { Camera, CheckCircle2, MapPin, Link } from 'lucide-react'

// 扩展的用户类型
interface ExtendedUser {
  first_name: string
  last_name?: string
  username?: string
  photo_url?: string
  bio?: string
  location?: string
  website?: string
  verified?: boolean
}

export default function UserCard() {
  const { user } = useTelegram()

  // 模拟用户数据（当 Telegram 用户不可用时）
  const mockUser: ExtendedUser = {
    first_name: '用户',
    last_name: '名称',
    username: 'username',
    bio: '这是我的个人简介',
    location: '北京市',
    website: 'example.com',
    verified: true,
  }

  // 合并 Telegram 用户和模拟用户数据
  const displayUser: ExtendedUser = user ? {
    ...mockUser,
    first_name: user.first_name,
    last_name: user.last_name,
    username: user.username,
    photo_url: user.photo_url,
  } : mockUser

  return (
    <div className="px-4 pt-4">
      <div className="relative">
        {/* 背景封面 */}
        <div className="h-24 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-t-2xl" />
        
        {/* 头像 */}
        <div className="absolute left-4 -bottom-10">
          <div className="relative">
            <div className="w-20 h-20 bg-telegram-blue rounded-2xl border-4 border-telegram-bg flex items-center justify-center overflow-hidden">
              {displayUser.photo_url ? (
                <img
                  src={displayUser.photo_url}
                  alt="avatar"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-2xl font-bold text-white">
                  {displayUser.first_name?.charAt(0) || 'U'}
                </span>
              )}
            </div>
            {/* 编辑头像按钮 */}
            <button className="absolute -bottom-1 -right-1 w-7 h-7 bg-telegram-dark rounded-full border-2 border-telegram-bg flex items-center justify-center">
              <Camera className="w-3.5 h-3.5 text-telegram-secondary" />
            </button>
          </div>
        </div>

        {/* 卡片主体 */}
        <div className="bg-telegram-dark rounded-b-2xl pt-12 pb-4 px-4">
          {/* 用户名区域 */}
          <div className="flex items-start justify-between">
            <div>
              <div className="flex items-center space-x-2">
                <h2 className="text-xl font-bold text-telegram-text">
                  {displayUser.first_name} {displayUser.last_name}
                </h2>
                {displayUser.verified && (
                  <CheckCircle2 className="w-5 h-5 text-blue-400" />
                )}
              </div>
              <p className="text-telegram-secondary text-sm mt-1">
                @{displayUser.username || 'username'}
              </p>
            </div>
          </div>

          {/* 简介 */}
          <p className="text-telegram-text mt-3 text-sm leading-relaxed">
            {displayUser.bio || '这是我的个人简介'}
          </p>

          {/* 附加信息 */}
          <div className="flex flex-wrap gap-3 mt-4">
            {displayUser.location && (
              <div className="flex items-center space-x-1 text-sm text-telegram-secondary">
                <MapPin className="w-4 h-4" />
                <span>{displayUser.location}</span>
              </div>
            )}
            {displayUser.website && (
              <div className="flex items-center space-x-1 text-sm text-telegram-secondary">
                <Link className="w-4 h-4" />
                <span>{displayUser.website}</span>
              </div>
            )}
          </div>

          {/* 统计数据 */}
          <div className="flex items-center space-x-6 mt-4 pt-4 border-t border-telegram-secondary/20">
            <div className="text-center">
              <p className="text-lg font-semibold text-telegram-text">128</p>
              <p className="text-xs text-telegram-secondary">好友</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-semibold text-telegram-text">56</p>
              <p className="text-xs text-telegram-secondary">群组</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-semibold text-telegram-text">12</p>
              <p className="text-xs text-telegram-secondary">频道</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
